/*
 * TPS — <tps-cookie-banner> (sections/tps-cerez-banner.liquid). YALNIZ GÖSTERİM.
 * Seçim localStorage'a yazılır ({ v, choice, categories, ts }) ve `tps:cookie:choice` olayı yayınlanır.
 * Shopify Customer Privacy API'ye / takip kodlarına dokunmaz — gerçek onay sistemi kurulduğunda bu olaya bağlanır.
 * Tema yardımcıları: trapFocus / removeTrapFocus (global.js). Yoksa odak yönetimi yalnız ilk alana odaklanır.
 */
if (!customElements.get('tps-cookie-banner')) {
  class TpsCookieBanner extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.key = this.dataset.storageKey || 'tps_cerez_v1';
      this.banner = this.querySelector('.tps-cc__banner');
      this.dialog = this.querySelector('.tps-cc__dialog');
      this.card = this.querySelector('.tps-cc__card');
      this.switches = [...this.querySelectorAll('.tps-cc__switch')];

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-cc]');
        if (!btn || !this.contains(btn)) return;
        const action = btn.dataset.cc;
        if (action === 'accept') this.choose('accept_all');
        else if (action === 'reject') this.choose('reject_all');
        else if (action === 'save') this.choose('custom');
        else if (action === 'manage') this.openDialog(btn);
        else if (action === 'close') this.closeDialog();
      });
      this.onKey = (e) => {
        if (e.key === 'Escape' && this.dialog && !this.dialog.hidden) {
          e.preventDefault();
          this.closeDialog();
        }
      };
      document.addEventListener('keydown', this.onKey);
      // Footer vb. herhangi bir yerdeki #cerez-tercihleri bağlantısı tercih penceresini açar.
      this.onDocClick = (e) => {
        const a = e.target.closest('a[href$="#cerez-tercihleri"]');
        if (!a) return;
        e.preventDefault();
        this.openDialog(a);
      };
      document.addEventListener('click', this.onDocClick);

      if (window.Shopify && Shopify.designMode) {
        this.bindEditor();
        this.showBanner();
        return;
      }

      const saved = this.read();
      if (this.dataset.mode === 'always' || !saved) {
        const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this.timer = setTimeout(() => this.showBanner(), delay);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    read() {
      try {
        const raw = window.localStorage.getItem(this.key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    write(state) {
      try {
        window.localStorage.setItem(this.key, JSON.stringify(state));
      } catch (e) {
        /* depolama kapalı: seçim bu sayfa için geçerli kalır */
      }
    }

    categories(choice) {
      const out = {};
      this.switches.forEach((s) => {
        const key = s.dataset.cat;
        if (s.hasAttribute('data-required')) out[key] = true;
        else if (choice === 'accept_all') out[key] = true;
        else if (choice === 'reject_all') out[key] = false;
        else out[key] = s.checked;
      });
      return out;
    }

    choose(choice) {
      const state = { v: 1, choice, categories: this.categories(choice), ts: new Date().toISOString() };
      if (!(window.Shopify && Shopify.designMode)) this.write(state);
      this.syncSwitches(state);
      document.dispatchEvent(new CustomEvent('tps:cookie:choice', { detail: state }));
      const fromDialog = this.dialog && !this.dialog.hidden;
      this.closeDialog(false);
      this.hideBanner();
      // Seçimden sonra ekranda ikon kalmaz (owner); odak sayfanın başına değil, açan öğe görünürse ona döner.
      if (fromDialog && this.opener && this.opener.isConnected && !this.opener.closest('[hidden]')) this.opener.focus();
    }

    syncSwitches(state) {
      const cats = (state && state.categories) || {};
      this.switches.forEach((s) => {
        if (s.hasAttribute('data-required')) s.checked = true;
        else s.checked = cats[s.dataset.cat] === true; // varsayılan KAPALI (önceden işaretli onay yok)
      });
    }

    showBanner() {
      if (!this.banner) return;
      this.banner.hidden = false;
      requestAnimationFrame(() => this.banner.classList.add('is-visible'));
    }

    hideBanner() {
      if (!this.banner) return;
      this.banner.classList.remove('is-visible');
      this.banner.hidden = true;
    }


    openDialog(opener) {
      if (!this.dialog) return;
      this.opener = opener || document.activeElement;
      this.syncSwitches(this.read());
      this.dialog.hidden = false;
      document.documentElement.classList.add('tps-cc-lock');
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      const first = this.card.querySelector('.tps-cc__switch:not([disabled])') || this.card;
      if (typeof trapFocus === 'function') trapFocus(this.card, first);
      else first.focus();
    }

    closeDialog(restore = true) {
      if (!this.dialog || this.dialog.hidden) return;
      this.dialog.classList.remove('is-open');
      this.dialog.hidden = true;
      document.documentElement.classList.remove('tps-cc-lock');
      const back = restore && this.opener && this.opener.isConnected && !this.opener.closest('[hidden]') ? this.opener : null;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(back);
      else if (back) back.focus();
    }

    bindEditor() {
      const mine = (e) => e.detail && e.detail.sectionId === this.dataset.sectionId;
      this.onSelect = (e) => { if (mine(e)) this.showBanner(); };
      this.onDeselect = (e) => { if (mine(e)) { this.closeDialog(false); this.showBanner(); } };
      this.onBlockSelect = (e) => { if (mine(e)) this.openDialog(); };
      document.addEventListener('shopify:section:select', this.onSelect);
      document.addEventListener('shopify:section:deselect', this.onDeselect);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  customElements.define('tps-cookie-banner', TpsCookieBanner);
}
